const env = process.env.NODE_ENV
console.log(process.env)
const baseURL  = {
  // development: 'http://172.30.6.110:18080/',
  development: "/",
  // development: 'http://172.30.6.81/',
  production: location.origin + '/'
}

export default baseURL[env]



